module.exports = "uniform sampler2D u_Texture;\r\nuniform vec2 u_Delta;\r\nvarying vec2 v_Uv;\r\nvoid main() {\r\n\tvec4 info = texture2D(u_Texture, v_Uv);\r\n\tvec2 dx = vec2(u_Delta.x, 0.0);\r\n\tvec2 dy = vec2(0.0, u_Delta.y);\r\n\tfloat average = (texture2D(u_Texture, v_Uv - dx).r + texture2D(u_Texture, v_Uv - dy).r + texture2D(u_Texture, v_Uv + dx).r + texture2D(u_Texture, v_Uv + dy).r) * 0.25;\r\n\tinfo.g += (average - info.r) * 2.0;\r\n\tinfo.g *= 0.995;\r\n\tinfo.r += info.g;\r\n\tgl_FragColor = info;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/js/shader/vertexInfo/stepShader.glsl
// module id = 22
// module chunks = 0